if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productInfo = this.closest('product-info');
        this.mainSubmitButton = this.productInfo?.querySelector(`#ProductSubmitButton-${this.sectionId}`);
        this.submitButton = this.querySelector('[data-sticky-add-to-cart-submit]');
        this.submitButtonText = this.querySelector('[data-sticky-add-to-cart-button-text]');
        this.variant = this.querySelector('[data-sticky-add-to-cart-variant]');
        this.variantTitle = this.querySelector('[data-sticky-add-to-cart-variant-title]');

        if (!this.productInfo || !this.mainSubmitButton || !this.submitButton) {
          this.remove();
          return;
        }

        this.submitButton.addEventListener('click', this.handleSubmit.bind(this));
        this.mainButtonObserver = new MutationObserver(this.syncSubmitButton.bind(this));
        this.mainButtonObserver.observe(this.mainSubmitButton, {
          attributes: true,
          attributeFilter: ['aria-disabled', 'class', 'disabled'],
          childList: true,
          subtree: true,
        });

        this.onScroll = this.updateVisibility.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));

        this.syncSubmitButton();
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.mainButtonObserver?.disconnect();
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.variantChangeUnsubscriber?.();
      }

      handleSubmit() {
        if (this.mainSubmitButton.disabled || this.mainSubmitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.disabled = true;
        this.submitButton.classList.add('loading');
        this.mainSubmitButton.click();
        this.syncSubmitButton();
      }

      syncSubmitButton() {
        const mainButtonText = this.mainSubmitButton.querySelector('span')?.textContent.trim();
        const isDisabled =
          this.mainSubmitButton.disabled || this.mainSubmitButton.getAttribute('aria-disabled') === 'true';
        const isLoading = this.mainSubmitButton.classList.contains('loading');

        this.submitButton.disabled = isDisabled;
        this.submitButton.classList.toggle('loading', isLoading);
        if (mainButtonText) this.submitButtonText.textContent = mainButtonText;
      }

      handleVariantChange(event) {
        if (event.data.sectionId !== this.sectionId) return;

        const { variant } = event.data;
        this.variant.hidden = !variant;
        if (variant) this.variantTitle.textContent = variant.title;

        this.syncSubmitButton();
      }

      updateVisibility() {
        const pageEndOffset = 100;
        const mainButtonRect = this.mainSubmitButton.getBoundingClientRect();
        const hasPassedMainButton = mainButtonRect.bottom <= 0;
        const atPageEnd = window.scrollY + window.innerHeight + pageEndOffset >= document.documentElement.scrollHeight;

        this.classList.toggle('sticky-add-to-cart--out', !hasPassedMainButton);
        this.classList.toggle('sticky-add-to-cart--page-end', atPageEnd);
      }
    }
  );
}
